import React from "react";
import Text from '@/bit/components/components.text'
import CmsClickToCall from "@/bit/components/components.cms-block.cms-click-to-call";
import StepItem from './step-item';

const StepList = (props) => {
  const cmsHandler = props?.cmsHandler;
  const { c2cProps, stepsProps } = props;

  const titleProps = stepsProps['cms-atom-text-1']
  const characValues = stepsProps['cms-ml-single-step-list'];
  const wrapElementsOnDivs = (stepsProps?.wrapElementsOnDivs || props.cmsHandler) || false;
  const className = props?.className;

  if (wrapElementsOnDivs) {
    return (
      <div className="steps-characteristics">
        {titleProps && (
          <div className={`${className} steps-characteristics--title`}>
            <Text {...titleProps} cmsHandler={cmsHandler} />
          </div>
        )}
        {characValues &&
          Array.isArray(characValues) &&
          characValues.length > 0 &&
          characValues.map((charac, i) => {
            return (
              <StepItem
                className={props?.className}
                charac={charac}
                index={i}
                cmsHandler={cmsHandler}
                displayLine={i < characValues.length - 1}
                key={`charact-item-${i}`}
              />
            )
          })}
        <CmsClickToCall
          cmsHandler={cmsHandler}
          {...c2cProps}
        />
        <style jsx>{`.steps-characteristics {
  display: flex;
  flex-direction: column;
  &--title {
    margin-bottom: 1.5rem;
  }
}`}</style>
      </div>
    );
  }

  return (
    <>
      {titleProps && (<Text {...titleProps} className={`${className} steps-characteristics--title`} />)}
      {characValues &&
        Array.isArray(characValues) &&
        characValues.length > 0 &&
        characValues.map((charac, i) => {
          return (
            <StepItem
              className={className}
              charac={charac}
              index={i}
              displayLine={i < characValues.length - 1}
              key={`charact-item-${i}`}
            />
          )
        })}
      <CmsClickToCall
        cmsHandler={cmsHandler}
        {...c2cProps}
      />
      {/* INJECT_STYLED_JSX_TAG */}
    </>
  )

};

export default StepList;
